"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderTags = exports.ReferenceGalleryItemPreview = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ActionsMenu = _interopRequireDefault(require("../ActionsMenu/ActionsMenu"));
var _TagsGroup = _interopRequireDefault(require("../TagsGroup/TagsGroup"));
var _LocalizedText = _interopRequireDefault(require("../LocalizedText/LocalizedText"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const defaultIcon = "data:image/svg+xml;base64,PHN2ZyBpZD0iaWNvbiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5uby1pbWFnZTwvdGl0bGU+PHBhdGggZD0iTTMwLDMuNDE0MSwyOC41ODU5LDIsMiwyOC41ODU5LDMuNDE0MSwzMGwyLTJIMjZhMi4wMDI3LDIuMDAyNywwLDAsMCwyLTJWNS40MTQxWk0yNiwyNkg3LjQxNDFsNy43OTI5LTcuNzkzLDIuMzc4OCwyLjM3ODdhMiwyLDAsMCwwLDIuODI4NCwwTDIyLDE5bDQsMy45OTczWm0wLTUuODMxOC0yLjU4NTgtMi41ODU5YTIsMiwwLDAsMC0yLjgyODQsMEwxOSwxOS4xNjgybC0yLjM3Ny0yLjM3NzFMMjYsNy40MTQxWiIvPjxwYXRoIGQ9Ik02LDIyVjE5bDUtNC45OTY2LDEuMzczMywxLjM3MzMsMS40MTU5LTEuNDE2LTEuMzc1LTEuMzc1YTIsMiwwLDAsMC0yLjgyODQsMEw2LDE2LjE3MTZWNkgyMlY0SDZBMi4wMDIsMi4wMDIsMCwwLDAsNCw2VjIyWiIvPjxyZWN0IGlkPSJfVHJhbnNwYXJlbnRfUmVjdGFuZ2xlXyIgZGF0YS1uYW1lPSImbHQ7VHJhbnNwYXJlbnQgUmVjdGFuZ2xlJmd0OyIgY2xhc3M9ImNscy0xIiB3aWR0aD0iMzIiIGhlaWdodD0iMzIiLz48L3N2Zz4=";
const renderTags = (categories, location, cantons) => {
  const items = [];
  categories.forEach(category => {
    items.push({
      label: category,
      type: 'tertiary'
    });
  });
  if (location) {
    items.push({
      label: location,
      type: 'primary'
    });
  }
  if (cantons) {
    cantons.forEach(canton => {
      items.push({
        label: canton,
        type: 'quaternary'
      });
    });
  }
  return /*#__PURE__*/_react.default.createElement(_TagsGroup.default, {
    items: items
  });
};
exports.renderTags = renderTags;
const ReferenceGalleryItemPreview = props => {
  const Component = props.elementToRender;
  const isPublished = props.published !== false;
  const getMimeType = base64Image => {
    const identifiers = [{
      type: 'image/png',
      code: 'iVBORw0KGgo'
    }, {
      type: 'image/jpg',
      code: '/9j/'
    }];
    const identifier = identifiers.find(identifier => base64Image.startsWith(identifier.code));
    return identifier ? identifier.type : null;
  };
  let renderableBase64Image = null;
  if (props.image) {
    const mimeType = getMimeType(props.image);
    renderableBase64Image = `data:${mimeType};base64,${props.image}`;
  } else {
    renderableBase64Image = defaultIcon;
  }
  const createClasses = () => {
    const classes = ['preview'];
    if (props.actions) {
      classes.push('with-actions');
    }
    if (isPublished) {
      classes.push('published');
    }
    return classes;
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: createClasses().join(' ')
  }, !isPublished && /*#__PURE__*/_react.default.createElement("div", {
    className: 'not-published-overlay',
    onClick: props.onClickUnpublished
  }, /*#__PURE__*/_react.default.createElement("span", null, props.translate('reference-gallery.project.not-published'))), /*#__PURE__*/_react.default.createElement("div", {
    className: 'actions-toolbar'
  }, props.actions && /*#__PURE__*/_react.default.createElement(_ActionsMenu.default, {
    actions: props.actions,
    translate: props.translate,
    name: props.title.name
  })), /*#__PURE__*/_react.default.createElement(Component, {
    className: 'info',
    to: props.url
  }, props.image ? /*#__PURE__*/_react.default.createElement("div", {
    className: 'thumb',
    style: {
      backgroundImage: `url(${renderableBase64Image})`
    }
  }) : /*#__PURE__*/_react.default.createElement("div", {
    className: 'thumb',
    style: {
      backgroundImage: `url(${renderableBase64Image})`,
      backgroundColor: "#4c4c4c",
      backgroundPosition: "center",
      backgroundSize: "42px",
      backgroundRepeat: "no-repeat"
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: 'text'
  }, renderTags(props.categories, props.location, props.cantons), /*#__PURE__*/_react.default.createElement("div", {
    className: 'company'
  }, props.company), /*#__PURE__*/_react.default.createElement("div", {
    className: 'name'
  }, /*#__PURE__*/_react.default.createElement(_LocalizedText.default, {
    lang: props.title.lang
  }, /*#__PURE__*/_react.default.createElement("h2", null, props.title.name))))));
};
exports.ReferenceGalleryItemPreview = ReferenceGalleryItemPreview;
ReferenceGalleryItemPreview.propTypes = {
  elementToRender: _propTypes.default.elementType.isRequired,
  url: _propTypes.default.string.isRequired,
  categories: _propTypes.default.array.isRequired,
  company: _propTypes.default.string.isRequired,
  title: _propTypes.default.shape({
    name: _propTypes.default.string.isRequired,
    lang: _propTypes.default.string
  }).isRequired,
  translate: _propTypes.default.func.isRequired,
  image: _propTypes.default.string,
  published: _propTypes.default.bool,
  onClickUnpublished: _propTypes.default.func,
  location: _propTypes.default.string,
  cantons: _propTypes.default.array,
  actions: _propTypes.default.object
};